import script from "./ModalClient.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalClient.vue?vue&type=script&setup=true&lang=js"

import "./ModalClient.vue?vue&type=style&index=0&id=8ee2998a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ee2998a"]])

export default __exports__